import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Alert,
  Link,
} from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

export const ForgotPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const { resetPasswordForEmail } = useAuthStore();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await resetPasswordForEmail(email);
      setSuccess(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Box>
        <Alert color="success" sx={{ mb: 3 }}>
          Check your email for a reset link.
        </Alert>
        <Link
          component="button"
          onClick={() => navigate("/auth?mode=signin")}
          sx={{ cursor: "pointer" }}
        >
          Back to sign in
        </Link>
      </Box>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ textAlign: "left" }}>
      {error && (
        <Alert color="danger" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <FormControl sx={{ mb: 3 }}>
        <FormLabel>Email</FormLabel>
        <Input
          type="email"
          required
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>

      <Button
        type="submit"
        fullWidth
        loading={loading}
        sx={{
          backgroundColor: "#FF6B4A",
          "&:hover": { backgroundColor: "#E55A3A" },
          mb: 2,
        }}
      >
        Send Reset Link
      </Button>

      <Box sx={{ textAlign: "center" }}>
        <Link
          component="button"
          onClick={() => navigate("/auth?mode=signin")}
          sx={{ cursor: "pointer" }}
        >
          Back to sign in
        </Link>
      </Box>
    </Box>
  );
};
